'use strict';
// import  tns  from 'tiny-slider/src/tiny-slider';

import * as dom from '../lib/dom.js';

const scrollCalendar = () =>  {


    const getFirstSlider = () =>{
        let CalendarItens = document.querySelectorAll('.c-container-dates .tns-slide-active' );
        let CalendarAllItens = document.querySelectorAll('.c-container-dates .tns-item' );
        let i ;

        for (i = 0; i < CalendarAllItens.length; i++) {
            CalendarAllItens[i].classList.remove('active');
        }

        CalendarItens[i].classList.add("active");
    }


    const control_position_slide = ()=>{
        let viewportWidth = window.innerWidth;

        if (viewportWidth > 1023) {
            return 'vertical' ;
        } else {
            return 'horizontal';
        }

    }

    console.log(control_position_slide());
    console.log('teste');

    if(Slider_events){
        Slider_events.destroy();
    }

    var Slider_events = tns({
        container: '.c-container-dates',
        mode: 'carousel',
        autoplay: false,
        nav: false,
        controls: true,
        slideBy: 1,
        gutter: 15,
        mouseDrag: true,
        loop: false,
        axis: control_position_slide(),
        // lazyload: true,
        swipeAngle: true,
          // onInit: getFirstSlider,
        // navContainer: '.c-podcast-content-dots',
        autoplayButtonOutput: false,
        responsive: {
            0: {
                items: 4,
            },769: {
                items: 9,
            },
            1036: {
                items: 9,

            }
        }
      });

      const CalendarAllItens = document.querySelectorAll('.c-container-dates .tns-item' );

        CalendarAllItens.forEach((el, eliIndex)=>{
            el.addEventListener('click', function() {
                console.log(eliIndex);
                Slider_events.goTo(eliIndex);
                const oldElActice = document.querySelector('.c-container-dates .tns-item.active' );
                if (oldElActice) {
                    dom.removeClass(oldElActice, 'active');
                }

                dom.addClass(el, 'active');


                const eventCard = this.getAttribute('data-cardEvent');
                if(eventCard){
                    const oldEventActice = document.querySelector('.c-podcast__covers-events.active' );
                    const event = document.querySelector('[data-event="'+eventCard+'"]');
                    dom.removeClass(oldEventActice, 'active');
                    dom.addClass(event, 'active');
                }
            });
        });

      Slider_events.getInfo();
}


export default function(){
    window.addEventListener('turbolinks:load', function() {
        if (document.querySelector('.c-podcast-date')) {
            scrollCalendar();
        }
    });

    window.addEventListener('resize', function() {
         if (document.querySelector('.c-podcast-date')) {
            scrollCalendar();
        }
    });
}
